module.exports = __webpack_public_path__ + "img/elektro_omara.28ff3d9b.jpg";